import { Tooltip } from 'antd';
import {InfoCircleOutlined }from "@ant-design/icons";

const TooltipIndependent = () => (
  <Tooltip title="Select Multiple Independent variable columns">
    <span><InfoCircleOutlined /></span>
  </Tooltip>
);

export default TooltipIndependent;